import { Component, OnInit } from '@angular/core';
import { ViewChild, AfterViewInit } from '@angular/core';
import {LoginComponent} from "./login/login.component";
import {APIHelper} from "../apihelper";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit{

  isAuth: boolean = false;
  constructor() {
    APIHelper._isAuthBS.subscribe((data: any) => {
      this.isAuth = data;
    });
  }
  ngOnInit(): void {
    if (localStorage.getItem('isAuth') == null) {
      localStorage.setItem('isAuth', 'false');
      localStorage.setItem('token', '');
    } else {
      this.isAuth = localStorage.getItem('isAuth') == 'true';
    }
  }
}
